<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-dialog
                    title="信息更新结果"
                    :visible.sync="resultShow"
                    width="50%" lock-scroll
                    center
                >
                    <el-table :data="resultArray"
                              row-key="id + '_' + server_url"
                              stripe
                              style="width: 100%;"
                              :default-sort="{prop: 'id'}"
                    >
                        <el-table-column prop="server_name" label='服务器名' width="160" fixed></el-table-column>
                        <el-table-column prop="server_url" label='请求地址' width="300"></el-table-column>
                        <el-table-column prop="resStatus" label='响应结果' width="150"></el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="resultShow = false">关闭</el-button>
                    </div>
                </el-dialog>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="登录服信息" name="loginServerInfos">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>登录服信息</span>
                            </div>
                            <el-table :data="yunweiLoginList"
                                      row-key="id"
                                      border
                                      style="width: 100%;"
                                      :row-style="tableRowStyle"
                                      :default-sort="{prop: 'id'}">
                                <el-table-column prop="server_name" label='机器名' width="160"></el-table-column>
                                <el-table-column prop="server_type" label='访问地址' width="160"></el-table-column>
                                <el-table-column prop="server_url" label='访问地址' width="350"></el-table-column>
                            </el-table>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="登录参数设置" name="login_configuration">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>全局参数配置</span>
                            </div>
                            <el-table :data="loginConfiguration"
                                      row-key="id"
                                      border
                                      style="width: 100%;"
                                      :row-style="tableRowStyle"
                                      :default-sort="{prop: 'id'}">
                                <el-table-column prop="id" label='编号' width="150"></el-table-column>
                                <el-table-column prop="key_description" label='描述' width="500"></el-table-column>
                                <el-table-column prop="key_value" label='参数信息' width="300"></el-table-column>
                                <el-table-column label='参数处理' width="150">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="loginConfShow(scope.row)">编辑</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="全服白名单" name="global_white_setting">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>{{loginConfigurationWhite.key_description}}</span>
                            </div>
                            <el-form label-width="100px" label-suffix=":" label-position="right" style="margin-top: 20px;" >
                                <el-form-item label="数据库值" prop="white">
                                    {{loginConfigurationWhite.key_value}}
                                </el-form-item>
                                <el-form-item label="编辑值" prop="white">
                                    <el-input
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 4}"
                                        placeholder="请输入内容"
                                        v-model="loginConfigurationWhiteEditValue">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                            <el-button type="text" @click="modifyWhiteListStr">更新全服白名单设置</el-button>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="拦截设置（登录服关闭）" name="error_configuration1">
                        <el-card>
                            <el-form label-position="left" label-width="80px">
                                <el-form-item label="拦截开关">
                                    <el-input-number v-model="loginConfigurationClosedSwitch.key_value"></el-input-number>
                                    <span class="volley-tip">(1为关闭登录标识，其他不判断)</span>
                                </el-form-item>
                            </el-form>
                            <el-tabs v-model="loginClosedTabsValue" type="card">
                                <el-tab-pane
                                    v-for="(item2, index2) in langType"
                                    :key="item2.id"
                                    :label="item2.label"
                                    :name="item2.val"
                                >
                                    <span slot="label">{{item2.label}}<el-badge :value="(value.title == '' || value.content == '') ? '!' : ''" v-for="(value, key) in loginConfigurationClosedTipsContentMap" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>
                                    <template v-for="(value, key) in loginConfigurationClosedTipsContentMap" v-if ="item2.val == key">
                                        <el-card>
                                            <el-form label-position="left" label-width="60px">
                                                <el-form-item label='标题'>
                                                    <el-input v-model="value.title" placeholder="请输入标题"></el-input>
                                                </el-form-item>
                                                <el-form-item label='内容'>
                                                    <el-input v-model="value.content" type="textarea" :rows="3" placeholder="请输入内容">
                                                    </el-input>
                                                </el-form-item>
                                            </el-form>
                                        </el-card>
                                    </template>

                                </el-tab-pane>
                            </el-tabs>
                            <el-button type="text" @click="globalLoginBlock">更新登录服关闭配置信息</el-button>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="拦截设置（SDK异常）" name="error_configuration2">
                        <el-card>
                            <el-tabs v-model="sdkErrorTabsValue" type="card">
                                <el-tab-pane
                                    v-for="(item2, index2) in langType"
                                    :key="item2.id"
                                    :label="item2.label"
                                    :name="item2.val"
                                >
                                    <span slot="label">{{item2.label}}<el-badge :value="(value.title == '' || value.content == '') ? '!' : ''" v-for="(value, key) in sdkErrorNotice" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>
                                    <template v-for="(value, key) in sdkErrorNotice" v-if ="item2.val == key">
                                        <el-card>
                                            <el-form label-position="left" label-width="60px">
                                                <el-form-item label='标题'>
                                                    <el-input v-model="value.title" placeholder="请输入标题"></el-input>
                                                </el-form-item>
                                                <el-form-item label='内容'>
                                                    <el-input v-model="value.content" type="textarea" :rows="3" placeholder="请输入内容">
                                                    </el-input>
                                                </el-form-item>
                                            </el-form>
                                        </el-card>
                                    </template>

                                </el-tab-pane>
                            </el-tabs>
                            <el-button type="text" @click="sdkErrorModify">更新SDK异常配置信息</el-button>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="拦截设置（登录服异常）" name="error_configuration3">
                        <el-card>
                            <el-tabs v-model="loginErrorTabsValue" type="card">
                                <el-tab-pane
                                    v-for="(item2, index2) in langType"
                                    :key="item2.id"
                                    :label="item2.label"
                                    :name="item2.val"
                                >
                                    <span slot="label">{{item2.label}}<el-badge :value="(value.title == '' || value.content == '') ? '!' : ''" v-for="(value, key) in loginErrorNotice" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>

                                    <template v-for="(value, key) in loginErrorNotice" v-if ="item2.val == key">
                                        <el-card>
                                            <el-form label-position="left" label-width="60px">
                                                <el-form-item label='标题'>
                                                    <el-input v-model="value.title" placeholder="请输入标题"></el-input>
                                                </el-form-item>
                                                <el-form-item label='内容'>
                                                    <el-input v-model="value.content" type="textarea" :rows="3" placeholder="请输入内容">
                                                    </el-input>
                                                </el-form-item>
                                            </el-form>
                                        </el-card>
                                    </template>

                                </el-tab-pane>
                            </el-tabs>
                            <el-button type="text" @click="loginErrorModify">更新登录服异常配置信息</el-button>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>

                <el-dialog :title="loginInfoEditForm.key_description" :visible.sync="loginConfShowTag" width="50%" lock-scroll center>
                    <template></template>
                    <el-form label-width="100px" label-suffix=":" label-position="right" style="margin-top: 20px;" >
                        <el-form-item label="原数据">
                            <span>{{loginInfoEditForm.key_value}}</span>
                        </el-form-item>
                        <el-form-item label="编辑数据" prop="white">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                v-model="loginConfigurationEditValue">
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="loginConfShowTag = false">取消</el-button>
                        <el-button type="primary" @click="loginConfigurationConfirm">确认</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
import commonApi from '../../service/common_api'
import yunweiServerApi from '../../service/yunwei_server_api'
import gameApi from '../../service/game_api'
import loginApi from '../../service/login_api'
import actionConfirm from '../../mixins/action_confirm'
import {mapState} from 'vuex';

export default {
    data() {
        return {
            title: this.$route.meta.title,
            activeName:'loginServerInfos',
            resultShow:false,
            resultArray:[],
            yunweiLoginList:[],
            yunweiNodeList:[],
            loginInfoGame:[],
            loginConfiguration:[],

            loginConfShowTag:false,
            loginInfoEditForm:{},
            loginConfigurationEditValue:'',

            loginConfigurationWhite:{},
            loginConfigurationWhiteEditValue:'',
            loginConfigurationClosedTips:{},
            loginConfigurationClosedTipsContentMap:{},
            loginConfigurationClosedSwitch:{},

            loginClosedTabsValue: 'zh-Hans',

            sdkErrorTabsValue: 'zh-Hans',
            sdkErrorNotice:{
                'zh-Hans': {title: "", content: ""},
                'zh-Hant': {title: "", content: ""},
                'ja-JP': {title: "", content: ""},
                'ko-KR': {title: "", content: ""},
                'ru-RU': {title: "", content: ""},
                'en-US': {title: "", content: ""},
            },

            loginErrorTabsValue: 'zh-Hans',
            loginErrorNotice:{
                'zh-Hans': {title: "", content: ""},
                'zh-Hant': {title: "", content: ""},
                'ja-JP': {title: "", content: ""},
                'ko-KR': {title: "", content: ""},
                'ru-RU': {title: "", content: ""},
                'en-US': {title: "", content: ""},
            }
        }
    },
    mixins: [actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken
        }),
    },
    mounted() {
    },
    created() {
        this.getLangs();
        this.grabYunweiLoginInfo();
        this.grabLoginInfoData("login_info_game");
    },
    methods: {
        handleClick(tab, event) {
            this.grabYunweiLoginInfo();
        },
        // 修改颜色
        tableRowStyle({row, rowIndex}) {
            return 'background-color:rgba(57,139,234,0.2)'
        },
        // 获取登录服和战斗服数据
        grabYunweiLoginInfo() {
            let self = this;
            commonApi.getConfs({
                tables: 'login_info_game,yunwei_server_config,login_configuration,configuration'
            }).then(res => {
                self.yunweiLoginList = [];
                self.yunweiNodeList = [];
                self.loginConfiguration = [];
                let yunweiServerConfig = res.yunwei_server_config;
                yunweiServerConfig.forEach(item => {
                    if (item.server_type == 'login') {
                        self.yunweiLoginList.push(item);
                    }else if (item.server_type == 'battleValidate') {
                        self.yunweiNodeList.push(item);
                    }
                })

                res.login_configuration.forEach(configurationItem=>{
                    switch (configurationItem.id){
                        case 101:
                            self.loginConfigurationWhite = configurationItem;
                            self.loginConfigurationWhiteEditValue = configurationItem.key_value;
                            break;
                        case 103:
                            self.loginConfigurationClosedSwitch = configurationItem;
                            break;
                        case 104:
                            self.loginConfigurationClosedTips = configurationItem;
                            self.loginConfigurationClosedTipsContentMap = JSON.parse(configurationItem.key_value);
                            break;
                        case 102:
                        case 107:
                        case 203:
                            break;
                        default:
                            self.loginConfiguration.push(configurationItem);
                            break;
                    }
                });


                self.globalConfiguration = res.configurtion;
            })
        },

        grabLoginInfoData(tableName){
            commonApi.getConfs({
                tables: tableName
            }).then(res => {
                if (tableName === 'login_info_game') {
                    console.log(res)
                    let sourceGameInfo = res[tableName];
                    this.loginInfoGame = [];
                    let subInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }
                }
            })
        },
        /**
         * 登录服重载
         */
        reloadAxioxLogin(){
            let self = this;
            self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                self.resultArray.push({
                    server_url: yunweiLoginInfo.server_url,
                    server_name: yunweiLoginInfo.server_name,
                    resStatus: '0'
                });
                let reloadForm =
                    {
                        loginUri: yunweiLoginInfo.server_url,
                        type: yunweiLoginInfo.type,
                        className: 'LoginConfiguration',
                        serverName: yunweiLoginInfo.server_name
                    };

                loginApi.loginReloadConfig({
                    token: self.token,
                    reloadForm: reloadForm
                }).then(res => {
                    self.resultArray.forEach(resultItem => {
                        if (resultItem.server_url == reloadForm.loginUri) {
                            resultItem.resStatus = res.resStatus
                        }
                    })
                    console.log("登录服信息列表重载成功")
                })
            })
        },
        // 重载游戏服
        reloadAxiosGame(reloadGameArray) {
            let self = this;
            self.resultShow = true;
            self.resultArray = [];

            self.reloadAxioxLogin();

            if (reloadGameArray !== undefined) {
                reloadGameArray.forEach(reloadGameInfo =>{
                    self.reloadGameItem(reloadGameInfo);
                })
            }
        },

        /**
         * 重载单个游戏服
         * @param reloadGameInfo
         */
        reloadGameItem(reloadGameInfo){
            let self = this;
            let balanceIps = reloadGameInfo.inner_urls.split(';');
            balanceIps.forEach(item => {
                if ('' != item) {
                    self.resultArray.push({
                        server_url: item,
                        server_name: reloadGameInfo.server_name,
                        resStatus: '0'
                    });
                    let reloadForm = {
                        uri: item,
                        type: 'game',
                        className: 'LoginConfiguration',
                        serverName: reloadGameInfo.server_name
                    }
                    gameApi.gameReloadConfig({
                        token: self.token,
                        reloadForm: reloadForm
                    }).then(res => {
                        self.resultArray.forEach(resultItem => {
                            if (resultItem.server_url == reloadForm.uri) {
                                resultItem.resStatus = res.resStatus
                            }
                        })
                    })
                }
            })
        },

        loginConfShow(row){
            this.loginConfShowTag = true;
            this.loginInfoEditForm = row;
            this.loginConfigurationEditValue = row.key_value;
        },

        loginConfigurationConfirm(){
            let self = this;
            let modifyForm = {};
            modifyForm[self.loginInfoEditForm.id] = self.loginConfigurationEditValue;
            this.$confirm('此操作会执行重载相关服务器（玩家无感）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                yunweiServerApi.modifyLoginConfiguration({
                    token: this.token,
                    modifyForm:modifyForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    if (self.loginInfoEditForm.id == 701 || self.loginInfoEditForm.id == 702 ||self.loginInfoEditForm.id == 703 ||self.loginInfoEditForm.id == 704){
                        self.reloadAxiosGame(self.loginInfoGame);
                    }
                    else{
                        self.reloadAxiosGame();
                    }

                    self.grabYunweiLoginInfo();
                    self.loginConfShowTag = false;
                })
            }).catch(cancel =>{
                this.$message({
                    type: 'fail',
                    message: '编辑已取消!'
                });
            });
        },


        // 修改白名单
        modifyWhiteListStr() {
            let self = this;
            this.$confirm('此操作会重载游戏服（玩家无感）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let modifyForm = {};
                modifyForm[self.loginConfigurationWhite.id] = self.loginConfigurationWhiteEditValue;
                yunweiServerApi.modifyLoginConfiguration({
                    token: this.token,
                    modifyForm:modifyForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    self.reloadAxiosGame(self.loginInfoGame);
                    self.grabYunweiLoginInfo();
                })
            }).catch(cancel =>{
                this.$message({
                    type: 'fail',
                    message: '编辑已取消!'
                });

            });
        },

        // 全局登录拦截
        globalLoginBlock() {
            let self = this;
            this.$confirm('此操作会重载游戏服（玩家无感）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let modifyForm = {};
                modifyForm[self.loginConfigurationClosedTips.id] = JSON.stringify(self.loginConfigurationClosedTipsContentMap);
                modifyForm[self.loginConfigurationClosedSwitch.id] = self.loginConfigurationClosedSwitch.key_value;
                yunweiServerApi.modifyLoginConfiguration({
                    token: this.token,
                    modifyForm:modifyForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '登录服拦截信息已更新!'
                    });
                    self.reloadAxiosGame(self.loginInfoGame);
                    self.grabYunweiLoginInfo();
                })
            }).catch(cancel =>{
                this.$message({
                    type: 'fail',
                    message: '编辑已取消!'
                });
            });
        },

        // 修改登录服异常公告
        loginErrorModify() {
            let self = this;
            yunweiServerApi.modifyLoginError({
                token: self.token,
                loginErrorModifyForm: {
                    contentMap: self.loginErrorNotice
                }
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                self.loginErrorNotice ={
                    'zh-Hans': {title: "", content: ""},
                    'zh-Hant': {title: "", content: ""},
                    'ja-JP': {title: "", content: ""},
                    'ko-KR': {title: "", content: ""},
                    'ru-RU': {title: "", content: ""},
                    'en-US': {title: "", content: ""},
                };
            })
        },

        // 修改sdk异常公告
        sdkErrorModify() {
            let self = this;
            yunweiServerApi.modifySdkError({
                token: self.token,
                sdkErrorModifyForm: {
                    contentMap: self.sdkErrorNotice
                }
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                self.sdkErrorNotice ={
                    'zh-Hans': {title: "", content: ""},
                    'zh-Hant': {title: "", content: ""},
                    'ja-JP': {title: "", content: ""},
                    'ko-KR': {title: "", content: ""},
                    'ru-RU': {title: "", content: ""},
                    'en-US': {title: "", content: ""},
                };
            })
        },
    }
};
</script>

<style lang="less">
.el-table__row .el-table__row--level-1 {
    background-color: #999999 !important;
}

.el-table:not(.el-table–scrollable-x) .el-table__fixed{
    height: 100% !important;
}

.server-row .el-input {
    margin-bottom: 10px;
}

.combine-tip {
    color: red;
    margin-bottom: 10px;
}

.upload-server {
    margin-left: 10px;
}

.sort-tip {
    color: red;
}

.white-list {
    width: 100px;
}

.volley-tip {
    color: red;
}

.login-btn-group {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/dev_tools/beasts_login.vue